import { Dispatch } from '@reduxjs/toolkit';
import { setBookingRestrictions } from '../actions';
import { AppState } from '../store';

export function getBookingRestrictions(): ReduxAction {
  return async (dispatch: Dispatch, getState: () => AppState) => {
    const {
      general: { appConfiguration, accessToken },
    } = getState();

    try {
      const data = await fetch(`${appConfiguration.VITE_API_SALES_CONFIGURATION}/api/bookingRestriction`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const bookingRestrictions = await data.json();
      dispatch(setBookingRestrictions(bookingRestrictions));
    } catch (error) {
      console.error(error);
    }
  };
}
